const SCROLL_LOCKED_CLASS = "scroll-locked";
const getLockElement = () => typeof document === "undefined" ? null : document.body || null;
const isScrollLocked = (lockElement) => {
  const element = lockElement || getLockElement();
  return element ? element.classList.contains(SCROLL_LOCKED_CLASS) : false;
};
const getScrollY = (scrollElement) => {
  if (!scrollElement && typeof window === "undefined") {
    return 0;
  }
  return scrollElement ? scrollElement.scrollTop : window.scrollY;
};
const setScrollY = (position, scrollElement) => {
  if (!scrollElement && typeof window === "undefined") {
    return;
  }
  if (scrollElement) {
    scrollElement.scrollTop = position;
  } else {
    window.scrollTo({ left: window.scrollX, top: position, behavior: "instant" });
  }
};
const lockScroll = (position, scrollElement, lockElement) => {
  const scrollY = position || getScrollY(scrollElement);
  const element = lockElement || getLockElement();
  if (!element) {
    return;
  }
  element.classList.add(SCROLL_LOCKED_CLASS);
  element.style.overflowY = "hidden";
  element.style.top = `-${scrollY}px`;
};
const unlockScroll = (position, scrollElement, lockElement) => {
  const element = lockElement || getLockElement();
  if (element === null) {
    return;
  }
  const top = position ? void 0 : element.style.top;
  const scrollY = top ? Math.abs(parseInt(top, 10)) : position || 0;
  let requestID;
  let frameTickCount = 0;
  const resetStyling = () => {
    element.classList.remove(SCROLL_LOCKED_CLASS);
    element.style.overflowY = "";
    resetTopStyling();
  };
  const resetTopStyling = () => {
    const removeTopStyling = () => {
      if (
        // Check if all the related initial `scroll-lock styling' has been removed
        !element.classList.contains(SCROLL_LOCKED_CLASS) && !element.style.overflowY && !element.style.position
      ) {
        if (frameTickCount >= 2) {
          element.style.top = "";
          cancelAnimationFrame(requestID);
        } else {
          ++frameTickCount;
          requestID = requestAnimationFrame(removeTopStyling);
        }
      }
    };
    requestID = requestAnimationFrame(removeTopStyling);
  };
  resetStyling();
  setScrollY(scrollY, scrollElement);
};
export {
  SCROLL_LOCKED_CLASS,
  getScrollY,
  isScrollLocked,
  lockScroll,
  setScrollY,
  unlockScroll
};
//# sourceMappingURL=scroll-lock.js.map
